import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/account/budget",
        component: List,
        name: "account.budget",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account/budget/create",
        component: Create,
        name: "account.budget.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account/budget/:id/edit",
        component: Edit,
        name: "account.budget.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
